module.exports = __webpack_public_path__ + "img/importHighlight.c59b5aba.svg";